<template>
  <v-card>
    <v-expansion-panel expand :value="[true]">
      <v-expansion-panel-content>
        <div slot="header">
          <v-icon>mdi-filter-variant</v-icon> Filters
        </div>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xl3 lg4 xs6>
                  <v-autocomplete :items="planList" v-model="filters.planNo" :label="filtersLabel.planNo" item-text="label" item-value="value" data-vv-name="planNo" :data-vv-as="filtersLabel.planNo" :error-messages="errors.collect('planNo')" clearable></v-autocomplete>
                </v-flex>
                <v-flex xl3 lg4 xs6>
                  <v-autocomplete :items="benefitList" v-model="filters.benefit" :label="filtersLabel.benefit" item-text="label" item-value="value" data-vv-name="benefit" :data-vv-as="filtersLabel.benefit" :error-messages="errors.collect('benefit')" clearable></v-autocomplete>
                </v-flex>
                <v-flex xl3 lg4 xs6>
                  <v-autocomplete :items="busClsList" v-model="filters.busCls" :label="filtersLabel.busCls" item-text="label" item-value="value" :error-messages="errors.collect('filters.busCls')" data-vv-name="busCls" :data-vv-as="filtersLabel.busCls" clearable></v-autocomplete>
                </v-flex>
                <v-flex xl3 lg4 xs6>
                  <v-autocomplete :items="tarfList" v-model="filters.tarf" :label="filtersLabel.tarf" item-text="label" item-value="value" :error-messages="errors.collect('filters.tarf')" data-vv-name="tarf" :data-vv-as="filtersLabel.tarf" clearable></v-autocomplete>
                </v-flex>
                <v-flex xl3 lg4 xs6>
                  <cal-picker :label="filtersLabel.effDate" v-model="filters.effDate" :error-messages="errors.collect('filters.effDate')" data-vv-name="effDate" :data-vv-as="filtersLabel.effDate"></cal-picker>
                </v-flex>
              </v-layout>
              <transition name="slide-x-transition" mode="out-in">
                <v-layout row wrap v-if="showDetailFilters">
                  <v-flex xl3 lg4 xs6>
                    <v-text-field v-model="filters.napSubLevel" :label="filtersLabel.napSubLevel" :error-messages="errors.collect('filters.napSubLevel')" data-vv-name="napSubLevel" :data-vv-as="filtersLabel.napSubLevel" v-validate="'numeric|max:10'"></v-text-field>
                  </v-flex>
                  <v-flex xl3 lg4 xs6>
                    <v-autocomplete :items="gapCalcMethodList()" v-model="filters.gapCalcMethod" :label="filtersLabel.gapCalcMethod" item-text="label" item-value="value" :error-messages="errors.collect('filters.gapCalcMethod')" data-vv-name="gapCalcMethod" :data-vv-as="filtersLabel.gapCalcMethod" clearable></v-autocomplete>
                  </v-flex>
                  <v-flex xl3 lg4 xs6>
                    <v-text-field v-model="filters.basedUom" :label="filtersLabel.basedUom" :error-messages="errors.collect('basedUom')" data-vv-name="basedUom" :data-vv-as="filtersLabel.basedUom" v-validate="'numeric|max:10'"></v-text-field>
                  </v-flex>
                </v-layout>
              </transition>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn flat="flat" @click.native="showDetailFilters = true" v-if="!showDetailFilters">Show More Filters</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat="flat" @click.native="doClearFilters">Clear Filters</v-btn>
            <v-btn color="primary" flat="flat" type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
          </v-card-actions>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-flex xs12>
      <v-layout row>
        <v-flex xs12 class="mt-3">
          <message :messages="messages"></message>
        </v-flex>
        <v-spacer></v-spacer>
        <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
          <v-btn color="secondary" class="white--text" slot="activator">
            <span>Columns</span>
            <v-icon right dark>mdi-table-column-plus-after</v-icon>
          </v-btn>
          <v-card>
            <v-card-text>
              <template v-if="columns.length > 0">
                <v-checkbox v-for="column in columns" :key="column.value" :label="column.text" :value="column.value" v-model="selectedColumns"></v-checkbox>
              </template>
              <template v-else>
                No column found
              </template>
            </v-card-text>
          </v-card>
        </v-menu>
      </v-layout>
    </v-flex>
    <v-data-table v-bind:headers="listHeaders" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="index" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
      <template slot="items" slot-scope="props">
        <td v-for="column in selectedColumns" :key="column">
          {{props.item[column]}}
        </td>
        <td class="text-xs-right">
          <table-action :rowData="props" review @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
        </td>
      </template>
    </v-data-table>
    <v-btn color="primary" dark class="mb-2" @click="doCreate">New Benefit<v-icon>mdi-plus</v-icon></v-btn>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Tariff Benefit?
      <div class="title">{{deleteTarfBen}}</div>
    </confirm>
  </v-card>
</template>

<script>
import FieldMixin from '@/mixins/field'
import MessageMixin from '@/mixins/message'
import { listMixin } from '@/components/parameters/reusable/listMixins'
import { filterQuery, expandURI } from '@/utils/ajax'
import { formatDisplayNumber, removeFormatNumber } from '@/utils/number.js'
import { pkgGapCalcMethod } from '@/const/underwriting/package'
export default {
  data() {
    return {
      benefitList: [],
      busClsList: [],
      tarfList: [],
      filtersLabel: {
        benefit: 'Benefit',
        tarf: 'Tariff',
        gapCalcMethod: 'Gap Calculation Method',
        busCls: 'Business Class',
        napSubLevel: 'Nap Sub Level',
        basedUom: 'Based Unit Of Measure',
        effDate: 'Effective Date',
        expDate: 'Expired Date',
        planNo: 'Plan'
      },
      filters: {
        planNo: null,
        benefit: null,
        tarf: null,
        gapCalcMethod: null,
        busCls: null,
        napSubLevel: null,
        addBen: null,
        defBen: null,
        minSi: null,
        maxSi: null,
        protSi: null,
        basedUom: null,
        effDate: null
      },
      columns: [
        { text: 'Benefit', value: 'benefitDesc' },
        { text: 'Business Class', value: 'busClsDesc' },
        { text: 'Tariff', value: 'tarfDesc' },
        { text: 'Gap Calculation Method', value: 'gapCalcMethod' },
        { text: 'Nap Sub Level', value: 'napSubLevel' },
        { text: 'Based Uom', value: 'basedUom' },
        { text: 'Effective Date', value: 'effDate' },
        { text: 'Expired Date', value: 'expDate' },
        { text: 'Plan', value: 'planDesc' }
      ],
      selectedColumns: ['planDesc', 'benefitDesc', 'effDate'],
      pagination: {
        sortBy: 'seqNo'
      },
      booleanList: [
        { label: 'Yes', value: true },
        { label: 'No', value: false }
      ],
      showDetailFilters: false,
      deleteTarfBen: '',
      promptRemove: false,
      planList: []
    }
  },
  watch: {
    'fetchBenefit': function(value) {
      if (value !== false) {
        this.fetchData(false)
      }
    },
    'pagination.descending': function (value) {
      this.fetchData(false)
    },
    'pagination.page': function (value) {
      this.fetchData(false)
    },
    'pagination.rowsPerPage': function (value) {
      this.fetchData(false)
    },
    'pagination.sortBy': function (value) {
      this.fetchData(false)
    }
  },
  computed: {
    schemeMenu() {
      return this.$store.state.parameters.scheme.schemeMenu.menu
    }
  },
  methods: {
    minValidation(value) {
      const min = removeFormatNumber(value)
      return 'mask_min_value:' + min
    },
    maxValidation(value) {
      const max = removeFormatNumber(value)
      return 'mask_max_value:' + max
    },
    async fetchData(options) {
      if (this.schemeMenu.init !== 1) {
        await this.$store.dispatch('schemeMenuInit', this.ids.scheme)
      }
      const apiURI = this.schemeMenu.pkgTarfBens
      Promise.all([this.doBusClsList(), this.doBenefitList(), this.doTarfList()])
      const { page, rowsPerPage } = this.pagination
      let expand = {
        scheme: this.ids.scheme,
        effDate: this.filters.effDate,
        page: page - 1,
        size: rowsPerPage
      }
      if (apiURI) {
        this.loading = true
        try {
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.descending))
          const { data } = result.data
          this.benefitList = result.data.benefitList
          this.planList = result.data.planList
          if (data) {
            this.items = []
            data.map((tarfBen) => {
              const convertTarfBen = {
                tarf: tarfBen.tarf,
                tarfDesc: tarfBen.tarfDesc,
                busCls: tarfBen.busCls,
                busClsDesc: tarfBen.busClsDesc,
                benefit: tarfBen.benefit,
                benefitDesc: tarfBen.benefitDesc,
                scheme: tarfBen.scheme,
                schemeDesc: tarfBen.schemeDesc,
                planNo: tarfBen.planNo,
                planDesc: tarfBen.planNoDesc,
                effDate: this.formatDate(tarfBen.effDate),
                expDate: this.formatDate(tarfBen.expDate),
                gapCalcMethod: tarfBen.gapCalcMethod + ' - ' + pkgGapCalcMethod[tarfBen.gapCalcMethod],
                napSubLevel: tarfBen.napSubLevel,
                basedUom: tarfBen.basedUom
              }
              this.items.push(convertTarfBen)
            })
            this.loading = false
          } else {
            this.items = []
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url - Tariff Benefit List')
      }
    },
    doClearFilters() {
      this.filters.planNo = null
      this.filters.benefit = null
      this.filters.tarf = null
      this.filters.gapCalcMethod = null
      this.filters.busCls = null
      this.filters.napSubLevel = null
      this.filters.addBen = null
      this.filters.defBen = null
      this.filters.minSi = null
      this.filters.maxSi = null
      this.filters.protSi = null
      this.filters.basedUom = null
      this.filters.effDate = null
      this.fetchData(true)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
          this.resetValidator()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doReview(data) {
      const ben = data.item
      this.$emit('doReview', ben)
    },
    doCreate() {
      this.$emit('doNew')
    },
    async doBenefitList() {
      const apiURI = this.schemeMenu.benefitList
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.benefitList = data.benefitList
        } else {
          this.benefitList = []
        }
      } else {
        this.benefitList = []
        this.errorMessage('Invalid API Url - Benefit List')
      }
    },
    async doBusClsList() {
      const apiURI = this.schemeMenu.busClsList
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.busClsList = data.pkgBusClsList
        } else {
          this.busClsList = []
        }
      } else {
        this.busClsList = []
        this.errorMessage('Invalid API Url - Business Class List')
      }
    },
    async doTarfList() {
      const apiURI = this.schemeMenu.tarfList
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.tarfList = data.pkgTarfList
        } else {
          this.tarfList = []
        }
      } else {
        this.tarfList = []
        this.errorMessage('Invalid API Url - Tariff List')
      }
    },
    gapCalcMethodList() {
      const list = Object.freeze(pkgGapCalcMethod)
      let convertArray = Object.keys(list).map(key => {
        return {
          label: key + ' - ' + list[key],
          value: key
        }
      })
      return convertArray
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedTarfBen = data
        this.deleteTarfBen = data.benefitDesc
      }
    },
    async doRemove() {
      const apiURI = this.schemeMenu.pkgTarfBenDelete
      if (apiURI) {
        this.loading = true
        if (this.selectedTarfBen.minSi === undefined) {
          this.selectedTarfBen.minSi = null
        }
        if (this.selectedTarfBen.maxSi === undefined) {
          this.selectedTarfBen.maxSi = null
        }
        const formatForm = {
          scheme: this.ids.scheme,
          planNo: this.ids.planNo,
          tarf: this.ids.tarf,
          busCls: this.ids.busCls,
          benefit: this.selectedTarfBen.benefit,
          gapCalcMethod: this.selectedTarfBen.gapCalcMethod,
          benType: this.selectedTarfBen.benType,
          napSubLevel: this.selectedTarfBen.napSubLevel,
          addBen: this.removeFormatBoolean(this.selectedTarfBen.addBen),
          defBen: this.removeFormatBoolean(this.selectedTarfBen.defBen),
          minSi: formatDisplayNumber(this.selectedTarfBen.minSi),
          maxSi: formatDisplayNumber(this.selectedTarfBen.maxSi),
          protSi: this.removeFormatBoolean(this.selectedTarfBen.protSi),
          basedUom: this.selectedTarfBen.basedUom,
          expDate: this.removeFormatDate(this.selectedTarfBen.expDate),
          effDate: this.removeFormatDate(this.selectedTarfBen.effDate)
        }
        try {
          const result = await this.$http.post(apiURI, formatForm)
          this.notify(result.data)
          // Reinit
          this.fetchData(true)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Delete Tariff Benefit')
      }
    },
    removeFormatDate(date) {
      if (date === null) {
        return null
      } else if (date === undefined) {
        return null
      } else if (date === '') {
        return null
      } else {
        var dateString = date
        var dateParts = dateString.split('/')
        return new Date(dateParts[2], dateParts[1] - 1, dateParts[0])
      }
    },
    removeFormatBoolean(boolean) {
      if (boolean === 'Yes') {
        return true
      } else {
        return false
      }
    }
  },
  props: {
    ids: Object,
    fetchBenefit: Boolean
  },
  mixins: [
    listMixin,
    MessageMixin,
    FieldMixin
  ]
}
</script>

<style>

</style>
